<template>
  <div
    class="w-full rounded-md cursor-pointer bg-green-900 px-2 pt-[11px] pb-[13px] text-center"
    @click="handleUpgradeToPro"
  >
    <div class="flex items-center justify-center mb-[3px]">
      <div
        class="font-semibold font-primary text-[15px] leading-[18px] text-green-200"
      >
        Upgrade to Pro
      </div>
      <Icon :size="12" class="ml-1 stroke-green-200 rotate-90" name="ArrowUp" />
    </div>
    <div class="font-secondary text-[14px] leading-[18px] text-green-100/90">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'
import { useDialog } from '@/shared/dialogs/useDialog'
import { Icon } from '@dacr/ui'

const router = useRouter()
const dialog = useDialog()

const handleUpgradeToPro = () => {
  router.push('/upgrade')
  dialog.closeAll()
}
</script>
